import React, {useState} from "react";
import {Container} from "react-bootstrap";
import PurposeBox from "../../Components/SalesAnalysis/PurposeBox.jsx";
import StickyFilterBlock from "../../Components/StickyFilterBlock.jsx";
import {filterZusammenfassung} from "../../Components/SalesAnalysis/format.js";
import AnalysisFilterBar from "../../Components/SalesAnalysis/AnalysisFilterBar.jsx";
import DataStatusBar from "../../Components/SalesAnalysis/DataStatusBar.jsx";
import GraffitiFineArtsView from "../../Components/SalesAnalysis/GraffitiFineArtsView.jsx";
import useAnalysisFilters from "../../Components/SalesAnalysis/useAnalysisFilters.js";

export default function SalesAnalysisGraffitiFineArts() {
    const filters = useAnalysisFilters();
    const [reloadToken, setReloadToken] = useState(0);
    const params = {...filters.params, _v: reloadToken};

    return (
        <Container fluid className="pt-2 pb-4">
            <PurposeBox />
            <h1 className="h4 mb-2">Graffiti vs. Fine Arts</h1>
            {filters.metaError && <div className="alert alert-warning">{filters.metaError}</div>}
            {filters.filtersReady && (
                <>
                    {/* Diese Sicht ignoriert den Branchenfilter bewusst (sie
                        IST der Branchenvergleich) - die Auswahl deshalb gar
                        nicht erst anzeigen (Befund E). */}
                    <StickyFilterBlock summary={filterZusammenfassung(filters)}>
                        <AnalysisFilterBar filters={filters} showSectors={false} />
                        <DataStatusBar meta={filters.meta} onRecalculated={() => setReloadToken((t) => t + 1)} />
                    </StickyFilterBlock>
                    <GraffitiFineArtsView params={params} meta={filters.meta} />
                </>
            )}
        </Container>
    );
}
